import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {Button, Card, Container, Grid, Icon, Popup, Table} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {paths} from '../../../common/dictionaries/urls';

const {
  fetchDevicesStock,
  navigateTo,
} = Actions;

const DevicesStock = () => {
  const permissions = useSelector((state) => state.session.permissions);
  const devicesStock = useSelector((state) => state.devicesStock.data);
  const dispatch = useDispatch();

  const refreshData = () => {
    dispatch(fetchDevicesStock());
  };

  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.DevicesStock, scopes.See)) {
      dispatch(navigateTo(paths.AccessDenied));
    }

    refreshData();
  }, []);

  return (<>
    <Card raised fluid>
      <div className='title-bar'>
        <Grid>
          <Grid.Row>
            <Grid.Column width={8}>
              <div className='title'>
                <h2>Stock Bodega Dispositivos</h2>
              </div>
            </Grid.Column>
            <Grid.Column textAlign='right' width={8} className='flex end'>
              <Popup inverted content='Actualizar'
                trigger={<Button circular compact
                  icon={<Icon name='refresh' size='large' link onClick={(e) => refreshData(e)} color='green' />}>
                </Button>} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </Card>
    <Container>
      <Card fluid>
        <Card.Content>
          <Table size='small' celled textAlign='center'>
            <Table.Header>
              <Table.HeaderCell>Bodega</Table.HeaderCell>
              <Table.HeaderCell>Código</Table.HeaderCell>
              <Table.HeaderCell>Descripción</Table.HeaderCell>
              <Table.HeaderCell>Cantidad</Table.HeaderCell>
            </Table.Header>
            <Table.Body>
              {devicesStock && devicesStock.map((item) => {
                return <Table.Row>
                  <Table.Cell>{item.warehouse}</Table.Cell>
                  <Table.Cell>{item.partCode}</Table.Cell>
                  <Table.Cell>{item.partDescription}</Table.Cell>
                  <Table.Cell>{item.stock}</Table.Cell>
                </Table.Row>;
              })}
            </Table.Body>
          </Table>
        </Card.Content>
      </Card>
    </Container>
  </>
  );
};

export default DevicesStock;
